import { render, staticRenderFns } from "./Zalandocategories.vue?vue&type=template&id=40971763"
import script from "./Zalandocategories.vue?vue&type=script&lang=js"
export * from "./Zalandocategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports